import { render } from "./SimpleRowNuggets.vue?vue&type=template&id=7dd90594"
import script from "./SimpleRowNuggets.vue?vue&type=script&lang=js"
export * from "./SimpleRowNuggets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/InfoNugget/SimpleRowNuggets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dd90594"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dd90594', __exports__)) {
    api.reload('7dd90594', __exports__)
  }
  
  module.hot.accept("./SimpleRowNuggets.vue?vue&type=template&id=7dd90594", () => {
    api.rerender('7dd90594', render)
  })

}


export default __exports__